import React from "react";
import { createStore } from "redux";
import { rootReducer } from "./app.store";
import { Provider } from "react-redux";
import { Route, Redirect, Router } from "react-router-dom";
import { composeWithDevTools } from "redux-devtools-extension";
import EmptyPage from "./modules/core/empty";

import LayoutApp from "./shared/layout/layout-app";
import AuthManagement from "shared/components/auth/auth-management";
import history from "shared/plugins/history";

import { Loading } from "shared/components/loading/loading";
import { ToastComponent } from "shared/components/toast/toast";
import { ModalComponent } from "shared/components/modal/modal-confirm";

import CartManagement from "shared/components/cart/cart-management";
import Cart from "modules/cart/cart";
import { Address } from "modules/address/address";
import Payment from "modules/payment/payment";
import Checkout from "modules/payment/checkout";

const store = createStore(rootReducer, composeWithDevTools());

function App() {
  return (
    <Provider store={store}>
      <Router history={history}>
          <Route path="/cart/empty" exact={true} component={EmptyPage} />
          <Route path="/" exact={true}>
              <Redirect to="/cart"></Redirect>
            </Route>
          <LayoutApp>
          <Route path="/cart" exact={true} component={Cart} />
          <Route path="/cart/address" exact={true} component={Address} />
          <Route path="/cart/checkout" exact={true} component={Payment} />
          <Route path="/cart/checkout/:orderId" exact={true} component={Checkout} />
        </LayoutApp>
        <ModalComponent />
        <ToastComponent />
        <AuthManagement />
        <CartManagement />
        <Loading />
      </Router>
    </Provider>
  );
}

export default App;
